<template>
  <div class="site-layout">
    <header class="site-header">
      <div class="site-header__inner">
        <div class="site-logo" @click="$router.push('/')">
          <img :src="logoUrl" alt="拼遇好物" class="site-logo__img" />
          <span class="site-logo__text">{{ siteInfo.name }}</span>
        </div>
        <nav class="site-nav">
          <router-link
            v-for="item in navMenus"
            :key="item.path"
            :to="item.path"
            class="site-nav__item"
            :class="{ active: isActive(item.path) }"
          >
            {{ item.label }}
          </router-link>
        </nav>
      </div>
    </header>

    <main class="site-main">
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="site-footer__inner">
        <div class="site-footer__grid">
          <div>
            <div class="site-footer__brand">{{ siteInfo.name }}</div>
            <div class="site-footer__desc">{{ siteInfo.description }}</div>
          </div>
          <div>
            <div class="site-footer__title">快速链接</div>
            <router-link v-for="item in navMenus" :key="item.path" :to="item.path" class="site-footer__link">
              {{ item.label }}
            </router-link>
          </div>
          <div>
            <div class="site-footer__title">App 下载</div>
            <a :href="androidDownload.url" :download="androidDownload.fileName" class="site-footer__link">
              {{ androidDownload.label }}
            </a>
          </div>
          <div>
            <div class="site-footer__title">法律信息</div>
            <router-link to="/privacy" class="site-footer__link">隐私政策</router-link>
            <router-link to="/terms" class="site-footer__link">用户协议</router-link>
            <router-link to="/contact" class="site-footer__link">联系我们</router-link>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { siteInfo, navMenus, androidDownload } from '@/data/site'
import logoUrl from '@/assets/logo.png'

export default {
  name: 'Layout',
  data() {
    return {
      logoUrl,
      siteInfo,
      navMenus,
      androidDownload,
    }
  },
  methods: {
    isActive(path) {
      if (path === '/') return this.$route.path === '/'
      return this.$route.path.startsWith(path)
    },
  },
}
</script>
